
    import Vue from 'vue';

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    
// 酒店(星级/钻级)枚举
export const HOTEL_CEM_STAR_TYPE_ENUM = {
  STAR: {
    label: $t('cef78a'),
  },
  DIAMOND: {
    label: $t('e03faf'),
  },
}

// 不同渠道分数保留小位数 2025年6月5日 前端总结  但是目前确认后端已经做了控制
// 2 携程 9 Booking.com 11 Expedia 12 Hotels.com 14 Agoda 23 逸粉 保留2位
// 其他保留1位

// 点评渠道枚举
export const HOTEL_COMMENT_CHANNEL = {
  MEITUAN: {
    value: '1',
    img: 'meituan.png',
    analysisTitle: $t('6f41a7'),
    commentTitle: $t('c3bf06'),
    order: 3,
    CommentAnalysisConfig: {
      channel: 'mt',
    },
    CommentListPageConfig: {
      name: $t('9a24ae'),
      totalBiKey: 'mtTotal',
      rawDataBiKey: $t('9a24ae'),
      formSearchValue: 'meituan',
      channel: 1,
      chineseSource: $t('9a24ae'),
    },
    competitor: 'meituan',
  },
  CTRIP: {
    value: '2',
    img: 'xiecheng.png',
    analysisTitle: $t('4f3275'),
    commentTitle: $t('a1d40e'),
    order: 0,
    CommentAnalysisConfig: {
      channel: 'xc',
    },
    CommentListPageConfig: {
      name: $t('e3f92d'),
      totalBiKey: 'xcTotal',
      rawDataBiKey: $t('e3f92d'),
      formSearchValue: 'ctrip',
      channel: 2,
      chineseSource: $t('e3f92d'),
    },
    competitor: 'ctrip',
  },
  ELONG: {
    value: '3',
    img: 'elong.png',
    analysisTitle: $t('7bbfe7'),
    commentTitle: $t('705f10'),
    order: 1,
    CommentAnalysisConfig: {
      channel: 'yl',
    },
    CommentListPageConfig: {
      name: $t('df1df6'),
      totalBiKey: 'ylTotal',
      rawDataBiKey: $t('c315a5'),
      formSearchValue: 'yilong',
      channel: 3,
      chineseSource: $t('df1df6'),
    },
    competitor: 'elong',
  },
  QUNAER: {
    value: '4',
    img: 'qunaer.png',
    analysisTitle: $t('fb237f'),
    commentTitle: $t('ce10a9'),
    order: 2,
    CommentAnalysisConfig: {
      channel: 'qnr',
    },
    CommentListPageConfig: {
      name: $t('13611a'),
      totalBiKey: 'qnrTotal',
      rawDataBiKey: $t('13611a'),
      formSearchValue: 'qunaer',
      channel: 4,
      chineseSource: $t('13611a'),
    },
    competitor: 'qunar',
  },
  FEIZHU: {
    value: '5',
    img: 'feizhu.png',
    analysisTitle: $t('8b9035'),
    commentTitle: $t('322e64'),
    order: 5,
    CommentAnalysisConfig: {
      channel: 'fz',
    },
    CommentListPageConfig: {
      name: $t('cf5ecd'),
      totalBiKey: 'fzTotal',
      rawDataBiKey: $t('cf5ecd'),
      formSearchValue: 'feizhu',
      channel: 5,
      chineseSource: $t('cf5ecd'),
    },
    competitor: 'fliggy',
  },
  DIANPING: {
    value: '6',
    img: 'dianping.png',
    analysisTitle: $t('8465d4'),
    commentTitle: $t('a27bcf'),
    order: 4,
    CommentAnalysisConfig: {
      channel: 'dp',
    },
    CommentListPageConfig: {
      name: $t('a27bcf'),
      totalBiKey: 'dpTotal',
      rawDataBiKey: $t('872e7e'),
      formSearchValue: 'dianping',
      channel: 6,
      chineseSource: $t('872e7e'),
    },
    competitor: 'dianping',
  },
  KY: {
    value: '7',
    img: 'kaiyuan.png',
    analysisTitle: $t('7529fa'),
    commentTitle: $t('ab3622'),
    order: 6,
    CommentAnalysisConfig: {
      channel: 'ky',
    },
    CommentListPageConfig: {
      name: $t('ca6b52'),
      totalBiKey: 'kyTotal',
      rawDataBiKey: $t('ca6b52'),
      formSearchValue: 'kaiyuan',
      channel: 7,
      chineseSource: $t('ca6b52'),
    },
    competitor: 'kaiyuan',
  },
  WANDA: {
    value: '8',
    img: 'wanda.png',
    analysisTitle: $t('dde19a'),
    commentTitle: $t('79a90b'),
    order: 8,
    CommentAnalysisConfig: {
      channel: 'custom_wanda',
    },
    CommentListPageConfig: {
      name: $t('d171f1'),
      totalBiKey: 'custom_wandaTotal',
      rawDataBiKey: $t('d171f1'),
      formSearchValue: 'custom_wanda',
      channel: 8,
      chineseSource: $t('d171f1'),
    },
    competitor: 'custom_wanda',
  },
  BOOKING: {
    value: '9',
    img: 'booking.png',
    analysisTitle: 'Booking.com ' + $t('a2cf77'),
    commentTitle: 'Booking.com ' + $t('872e7e'),
    order: 9,
    CommentAnalysisConfig: {
      channel: 'booking',
    },
    CommentListPageConfig: {
      name: 'Booking.com',
      totalBiKey: 'bookingTotal',
      rawDataBiKey: 'Booking',
      formSearchValue: 'booking',
      channel: 9,
      chineseSource: 'Booking',
    },
    competitor: 'booking',
  },
  TRIPADVISOR: {
    value: '10',
    img: 'tripadvisor.png',
    analysisTitle: $t('9e07d5'),
    commentTitle: $t('116696'),
    order: 10,
    CommentAnalysisConfig: {
      channel: 'tripadvisor',
    },
    CommentListPageConfig: {
      name: $t('ed7caf'),
      totalBiKey: 'tripadvisorTotal',
      rawDataBiKey: $t('ed7caf'),
      formSearchValue: 'tripadvisor',
      channel: 10,
      chineseSource: $t('ed7caf'),
    },
    competitor: 'tripadvisor',
  },
  EXPEDIA: {
    value: '11',
    img: 'expedia.png',
    analysisTitle: $t('0d7696'),
    commentTitle: $t('ae7a00'),
    order: 11,
    CommentAnalysisConfig: {
      channel: 'expedia',
    },
    CommentListPageConfig: {
      name: 'Expedia',
      totalBiKey: 'expediaTotal',
      rawDataBiKey: 'expedia',
      formSearchValue: 'expedia',
      channel: 11,
      chineseSource: 'expedia',
    },
    competitor: 'expedia',
  },
  HOTEL_COM: {
    value: '12',
    img: 'hotel.png',
    analysisTitle: $t('4beb30'),
    commentTitle: $t('f742cb'),
    order: 12,
    CommentAnalysisConfig: {
      channel: 'hotel_com',
    },
    CommentListPageConfig: {
      name: 'Hotels.com',
      totalBiKey: 'hotelComTotal',
      rawDataBiKey: 'Hotel',
      formSearchValue: 'hotel_com',
      channel: 12,
      chineseSource: 'Hotel',
    },
    competitor: 'hotel_com',
  },
  TRIPADVISOR_EN: {
    value: '13',
    img: 'TRIPADVISOR_EN.png',
    analysisTitle: $t('338504'),
    commentTitle: $t('ee99aa'),
    order: 13,
    CommentAnalysisConfig: {
      channel: 'tripadvisor_en',
    },
    CommentListPageConfig: {
      name: 'Tripadvisor',
      totalBiKey: 'tripadvisorEnTotal',
      rawDataBiKey: 'TripadvisorEn',
      formSearchValue: 'tripadvisor_en',
      channel: 13,
      chineseSource: 'TripadvisorEn',
    },
    competitor: 'tripadvisor_en',
  },
  AGODA: {
    value: '14',
    img: 'Agoda.png',
    analysisTitle: $t('75d575'),
    commentTitle: $t('c49801'),
    order: 14,
    CommentAnalysisConfig: {
      channel: 'agoda',
    },
    CommentListPageConfig: {
      name: 'Agoda',
      totalBiKey: 'agodaTotal',
      rawDataBiKey: 'Agoda',
      formSearchValue: 'agoda',
      channel: 14,
      chineseSource: 'Agoda',
    },
    competitor: 'agoda',
  },
  RUJIA: {
    value: '15',
    img: 'rujia.png',
    analysisTitle: $t('8239db'),
    commentTitle: $t('64ce5a'),
    order: 15,
    CommentAnalysisConfig: {
      channel: 'rujia',
    },
    CommentListPageConfig: {
      name: $t('b8ee0c'),
      totalBiKey: 'rujiaTotal',
      rawDataBiKey: $t('b8ee0c'),
      formSearchValue: 'rujia',
      channel: 15,
      chineseSource: $t('b8ee0c'),
    },
    competitor: 'rujia',
  },
  YASITE: {
    value: '16',
    img: 'yasite.png',
    analysisTitle: $t('c2f945'),
    commentTitle: $t('9c34c7'),
    order: 16,
    CommentAnalysisConfig: {
      channel: 'yasite',
    },
    CommentListPageConfig: {
      name: $t('d88d2c'),
      totalBiKey: 'yasiteTotal',
      rawDataBiKey: $t('d88d2c'),
      formSearchValue: 'yasite',
      channel: 16,
      chineseSource: $t('d88d2c'),
    },
    competitor: 'yasite',
  },
  DOUYIN: {
    value: '17',
    img: 'douyin.png',
    analysisTitle: $t('6381f4'),
    commentTitle: $t('f6360a'),
    order: 17,
    CommentAnalysisConfig: {
      channel: 'douyin',
    },
    CommentListPageConfig: {
      name: $t('92b56b'),
      totalBiKey: 'douyinTotal',
      rawDataBiKey: $t('92b56b'),
      formSearchValue: 'douyin',
      channel: 17,
      chineseSource: $t('92b56b'),
    },
    competitor: 'douyin',
  },
  JINJIANG: {
    value: '18',
    img: 'jinjiang.webp',
    analysisTitle: $t('74a264'),
    commentTitle: $t('f8059d'),
    order: 18,
    CommentAnalysisConfig: {
      channel: 'jinjiang',
    },
    CommentListPageConfig: {
      name: $t('9f826f'),
      totalBiKey: 'jinjiangTotal',
      rawDataBiKey: $t('9f826f'),
      formSearchValue: 'jinjiang',
      channel: 18,
      chineseSource: $t('9f826f'),
    },
    competitor: 'jinjiang',
  },
  YIFEI: {
    value: '19',
    img: 'yifei.png',
    analysisTitle: $t('d2bb09'),
    commentTitle: $t('4fe3c6'),
    order: 19,
    CommentAnalysisConfig: {
      channel: 'yifei',
    },
    CommentListPageConfig: {
      name: $t('27e021'),
      totalBiKey: 'yifeiTotal',
      rawDataBiKey: $t('27e021'),
      formSearchValue: $t('27e021'),
      channel: 19,
      chineseSource: $t('27e021'),
    },
    competitor: 'yifei',
  },
  GOOGLE: {
    value: '20',
    img: 'google.png',
    analysisTitle: $t('ad8c9c'),
    commentTitle: $t('97ddce'),
    order: 20,
    CommentAnalysisConfig: {
      channel: 'google',
    },
    CommentListPageConfig: {
      name: $t('4aff2b'),
      totalBiKey: 'googleTotal',
      rawDataBiKey: $t('4aff2b'),
      formSearchValue: $t('4aff2b'),
      channel: 20,
      chineseSource: $t('4aff2b'),
    },
    competitor: 'google',
  },
  BAIDA: {
    value: '21',
    img: 'dalong.png',
    analysisTitle: $t('f76c08'),
    commentTitle: $t('90166e'),
    order: 21,
    CommentAnalysisConfig: {
      channel: 'delonix',
    },
    CommentListPageConfig: {
      name: $t('d4478c'),
      totalBiKey: 'delonixTotal',
      rawDataBiKey: $t('d4478c'),
      formSearchValue: $t('d4478c'),
      channel: 21,
      chineseSource: $t('d4478c'),
    },
    competitor: 'delonix',
  },
  DLZHUZHONG: {
    value: '22',
    img: 'dalong.png',
    analysisTitle: $t('23c2a9'),
    commentTitle: $t('b699f3'),
    order: 22,
    CommentAnalysisConfig: {
      channel: 'delonix_zh',
    },
    CommentListPageConfig: {
      name: $t('b7c5fe'),
      totalBiKey: 'delonix_zhTotal',
      rawDataBiKey: $t('b7c5fe'),
      formSearchValue: $t('b7c5fe'),
      channel: 22,
      chineseSource: $t('b7c5fe'),
    },
    competitor: 'delonix_zh',
  },
  YIFEN: {
    value: '23',
    label: $t('44f60c'),
    img: 'yifen.png',
    analysisTitle: $t('53e94c'),
    commentTitle: $t('07aca4'),
    configValue: 23,
    order: 23,
    CommentAnalysisConfig: {
      channel: 'yifen',
    },
    CommentListPageConfig: {
      name: $t('44f60c'),
      totalBiKey: 'yifenTotal',
      rawDataBiKey: $t('44f60c'),
      formSearchValue: $t('44f60c'),
      channel: 23,
      chineseSource: $t('44f60c'),
    },
    competitor: 'yifen',
  },
  JINLING: {
    value: '24',
    label: $t('9850bb'),
    img: 'jinling.jpeg',
    analysisTitle: $t('4dc638'),
    commentTitle: $t('28a65e'),
    configValue: 24,
    order: 24,
    CommentAnalysisConfig: {
      channel: 'jinling',
    },
    CommentListPageConfig: {
      name: $t('9850bb'),
      totalBiKey: 'jinlingTotal',
      rawDataBiKey: $t('9850bb'),
      formSearchValue: $t('9850bb'),
      channel: 24,
      chineseSource: $t('9850bb'),
    },
    competitor: 'jinling',
  },
  GAODE: {
    value: '25',
    label: $t('d4e4d2'),
    img: 'gaode.png',
    analysisTitle: $t('e296c3'),
    commentTitle: $t('f734bc'),
    configValue: 25,
    order: 25,
    CommentAnalysisConfig: {
      channel: 'gaode',
    },
    CommentListPageConfig: {
      name: $t('d4e4d2'),
      totalBiKey: 'gaodeTotal',
      rawDataBiKey: $t('d4e4d2'),
      formSearchValue: $t('d4e4d2'),
      channel: 25,
      chineseSource: $t('d4e4d2'),
    },
    competitor: 'gaode',
  },
}

/**
 *0: '亲子出游',
  1: '代人预订',
  2: '商务出差',
  3: '团队出游',
  4: '夫妻/情侣',
  5: '家庭出游',
  6: '其他',
  7: '朋友出游',
  8: '爱宠人士',
  9: '独自出游'
 */
// 出游类型与点评渠道的映射关系
export const TRAVEL_TYPE_MAPPING = {
  0: {
    name: $t('62a033'),
    id: 1,
    en: 'Parent-child outings',
    channels: ['agoda', 'booking', 'ctrip', 'custom_wanda', 'elong', 'expedia', 'fliggy'],
  },
  1: { name: $t('ca0d44'), id: 9, en: 'Book for others', channels: ['ctrip', 'custom_wanda'] },
  2: {
    name: $t('c461b1'),
    id: 4,
    en: 'Business trip',
    channels: [
      'agoda',
      'ctrip',
      'custom_wanda',
      'dianping',
      'elong',
      'expedia',
      'fliggy',
      'hotel_com',
      'jinjiang',
      'qunar',
      'tripadvisor',
      'tripadvisor_en',
    ],
  },
  3: {
    name: $t('cc9980'),
    id: 8,
    en: 'Group trip',
    channels: ['agoda', 'booking', 'elong', 'expedia', 'jinjiang', 'tripadvisor'],
  },
  4: {
    name: $t('a89405'),
    id: 5,
    en: 'Couple / Lover',
    channels: [
      'agoda',
      'booking',
      'ctrip',
      'custom_wanda',
      'dianping',
      'elong',
      'expedia',
      'fliggy',
      'jinjiang',
      'qunar',
      'tripadvisor',
      'tripadvisor_en',
    ],
  },
  5: {
    name: $t('3918c8'),
    id: 3,
    en: 'Family trip',
    channels: ['agoda', 'ctrip', 'elong', 'expedia', 'hotel_com', 'jinjiang', 'tripadvisor', 'tripadvisor_en'],
  },
  6: {
    name: $t('97e49d'),
    id: 2,
    en: 'Others',
    channels: [
      'agoda',
      'booking',
      'ctrip',
      'custom_wanda',
      'delonix',
      'delonix_zh',
      'dianping',
      'douyin',
      'elong',
      'expedia',
      'fliggy',
      'google',
      'hotel_com',
      'jinjiang',
      'jinling',
      'kaiyuan',
      'meituan',
      'qunar',
      'rujia',
      'tripadvisor',
      'tripadvisor_en',
      'yaste',
      'yifei',
      'yifen',
    ],
  },
  7: {
    name: $t('37ada4'),
    id: 7,
    en: 'Friend trip',
    channels: [
      'agoda',
      'ctrip',
      'custom_wanda',
      'dianping',
      'elong',
      'fliggy',
      'hotel_com',
      'jinjiang',
      'tripadvisor_en',
    ],
  },
  8: { name: $t('28311b'), id: 10, en: 'Pet lovers', channels: ['expedia', 'fliggy'] },
  9: {
    name: $t('9228bc'),
    id: 6,
    en: 'Solo trip',
    channels: [
      'agoda',
      'booking',
      'ctrip',
      'custom_wanda',
      'dianping',
      'elong',
      'expedia',
      'fliggy',
      'jinjiang',
      'qunar',
      'tripadvisor',
      'tripadvisor_en',
    ],
  },
}

export const SHOW_TRAVEL_TYPE = [0, 1, 2, 3, 4, 5, 7, 8, 9]

export const getChannelByReserve = (reserveChannelIds = [], selectChannelIds = []) => {
  if (!reserveChannelIds.length) return []
  const channelMap = {}
  Object.values(HOTEL_COMMENT_CHANNEL).forEach(channel => {
    channelMap[channel.competitor] = channel.CommentListPageConfig
  })
  const channelNames = SHOW_TRAVEL_TYPE.map(type => {
    const { name, channels: allChannelSources, id, en } = TRAVEL_TYPE_MAPPING[type]
    const showChannels = allChannelSources.filter(channelName => {
      const channelObj = channelMap[channelName]
      return (
        channelObj &&
        reserveChannelIds.includes(channelObj.channel) &&
        (selectChannelIds.includes(channelName) || selectChannelIds.includes(channelObj.channel))
      )
    })
    return {
      tripPurpose: name,
      id: id,
      en: en,
      channelNames: showChannels.map(channelName => channelMap[channelName].name),
    }
  })

  return channelNames.filter(item => item.channelNames.length)
}

export const INDUSTRY_TYPE = [
  {
    industryType: 1,
    industryName: $t('8fddf4'),
  },
  {
    industryType: 2,
    industryName: $t('d3c589'),
  },
  {
    industryType: 3,
    industryName: $t('35c238'),
  },
]
